import { useRef, useState } from 'react';

import { emptyFieldErrorMessage } from '../constants/errorMessages';

export const useAutoSaveOnBlur = ({
    value,
    originalValue,
    isRequired = false,
    isDisabled = false,
    cssSelector = '',
    onChangeProp,
    onSaveProp,
}) => {
    const wrapperRef = useRef(null);
    const [errorMessage, setErrorMessage] = useState(null);

    const handleSave = async () => {
        if (value === originalValue) return;

        try {
            if (isRequired && !value) {
                setErrorMessage(emptyFieldErrorMessage);

                const editorEl = wrapperRef.current.querySelector(cssSelector);
                editorEl && editorEl.focus();

                return;
            }

            await onSaveProp(value);
        } catch (e) {
            console.log(e);
        }
    };

    const handleChange = (value) => {
        onChangeProp(value);
        if (errorMessage) setErrorMessage(null);
    };

    const state = isDisabled ? 'disabled' : errorMessage ? 'error' : 'default';

    return { wrapperRef, handleChange, handleSave, state, errorMessage };
};
